// extracted by mini-css-extract-plugin
export default {"tituloContainer":"styles_tituloContainer__49YQK","suspenseLoading":"styles_suspenseLoading__DQAJy","botaoVoltar":"styles_botaoVoltar__R7SEJ"};